import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFutureOrderStore } from '../../components/Stores/FutureOrdersStore';
import { useMaterialsStore } from '../../components/Stores/MaterialsStore';
import { useAccountStore } from '../../components/Stores/accountStore';
import ButtonDesigned from '../../components/UI-Elements/Buttons/ButtonDesigned';
import { useFutureOrders } from '../../hooks/useFutureOrders';
import { FutureOrdersSummeryGraphs } from './FutureOrders/FutureOrdersSummeryGraphs/FutureOrdersSummeryGraphs';
import { FutureOrdersTables } from './FutureOrders/FutureOrdersTables/FutureOrdersTables';
import { MaterialTrendButton } from '../Dashboard/MaterialTrendButton';
import { getMaterialsCardData } from '../Dashboard/dashboardUtils';
import { getFutureOrderExposedMaterials } from './FutureOrders/Utils';
import { useExposureStore } from '../../components/Stores/exposureDataStore';
import {
  ADD_FO_FIRST_STEP,
  ADD_FUTURE_ORDER_DEFAULT_ORDER_ID,
  ADD_FUTURE_ORDER_ROOT_ROUTE,
} from './AddNewFutureOrder/AddNewFutureOrderUtils';
import { useCurrencyRates } from '@hooks/useCurrencyRates';
import { useUser } from '@hooks/useUser';

export interface materialExposureDictionary {
  totalValue: number;
  totalWeight: number;
  exposureCalendar: Record<string, number>;
  price?: number;
}

export const FutureOrders = () => {
  const navigate = useNavigate();
  const { account, materialColorDictionary } = useAccountStore();
  const { data: user } = useUser();
  const { materials, isMaterialsLoading, materialsMap } = useMaterialsStore();
  const {
    netExposure,

    currentSelectedMaterialId,
    setCurrentSelectedMaterialId,
  } = useExposureStore();
  const { convertionMap } = useCurrencyRates();

  const { refetch, isLoading: isFutureOrderQueryLoading } = useFutureOrders();
  const { allFutureOrders, setIsFutureOrdersLoading, isFutureOrdersLoading, resetStore } = useFutureOrderStore();
  const [dataStatus, setDataStatus] = useState<'loading' | 'missing' | 'fetched'>('missing');
  const allFutureOrdersMaterials = getFutureOrderExposedMaterials(allFutureOrders);

  useEffect(() => {
    if (isMaterialsLoading || isFutureOrdersLoading) {
      setDataStatus('loading');
    } else if (materials.length > 0 && allFutureOrders.length > 0) {
      setDataStatus('fetched');
    } else {
      setDataStatus('missing');
    }
  }, [isMaterialsLoading, isFutureOrdersLoading, materials, allFutureOrders]);

  useEffect(() => {
    account.id && refetch();
  }, [account]);

  useEffect(() => {
    setIsFutureOrdersLoading(isFutureOrderQueryLoading);
  }, [isFutureOrderQueryLoading]);

  return (
    <div className="flex flex-col h-full  space-y-[1rem] ">
      <div className="flex justify-between">
        <div>
          <MaterialTrendButton
            buttons={getMaterialsCardData(
              materialsMap,
              materialColorDictionary,
              convertionMap,
              account.materialsToAccount.filter(
                (item) => allFutureOrdersMaterials.includes(item.materialId) || item.materialId === 'general',
              ),
              netExposure,
            )}
            currentMaterial={currentSelectedMaterialId}
            setCurrentMaterial={setCurrentSelectedMaterialId}
          />
        </div>
        {user?.isEditEnabled && (
          <ButtonDesigned
            style="primary"
            onButtonClick={() => {
              resetStore();
              navigate(`../${ADD_FUTURE_ORDER_ROOT_ROUTE}/${ADD_FUTURE_ORDER_DEFAULT_ORDER_ID}/${ADD_FO_FIRST_STEP}`);
            }}
          >
            Create order
          </ButtonDesigned>
        )}
      </div>
      <div>
        <FutureOrdersSummeryGraphs
          componentDataState={dataStatus}
          futureOrders={allFutureOrders}
          currentMaterialId={currentSelectedMaterialId}
        />
      </div>
      <div className="flex flex-col flex-1 grow ">
        <FutureOrdersTables
          componentDataState={dataStatus}
          futureOrders={allFutureOrders}
          currentSelectedMaterialId={currentSelectedMaterialId}
          refetchOrders={refetch}
          isEditEnabled={!!user?.isEditEnabled}
        />
      </div>
    </div>
  );
};
